import * as Yup from "yup";

export const adminSchema = Yup.object({
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  email: Yup.string().email().required("Required"),
  phone: Yup.string().required("Required"),
  roles: Yup.array()
    .of(Yup.string())
    .min(1, "At least one role must be selected")
    .required("Roles are required"),
});

export const technicianSchema = Yup.object({
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  email: Yup.string().email().required("Required"),
  phone: Yup.string().required("Required"),
  location: Yup.object({
  lat: Yup.number().required("Location required"),
  lng: Yup.number().required("Location required"),
}).nullable(),
});

export const customerSchema = Yup.object({
  firstName: Yup.string().required("Required"),
  lastName: Yup.string().required("Required"),
  email: Yup.string().email().required("Required"),
  phone: Yup.string().required("Required"),
  location: Yup.object({
  lat: Yup.number().required("Location required"),
  lng: Yup.number().required("Location required"),
}).nullable(),

  tractors: Yup.array()
    .of(
      Yup.object({
        model: Yup.string().required("Required"),
        serial: Yup.string().required("Required"),
        year: Yup.string().required("Required"),
        engineHours: Yup.string().required("Required"),
        engineType: Yup.string().required("Required"),
        horsePower: Yup.string().required("Required"),
        transmission: Yup.string().required("Required"),
      })
    )
    .min(1, "Add at least one tractor"),
});

